export function formatDate(date) {
  return new Date(date).toLocaleDateString();
}

export const trimString = (v) => (typeof v === 'string' ? v.trim() : v);

export const deepTrimStrings = (obj) => {
  if (Array.isArray(obj)) return obj.map(deepTrimStrings);
  if (obj && typeof obj === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(obj)) out[k] = deepTrimStrings(v);
    return out;
  }
  return trimString(obj);
};